import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { NavKeys } from '@common-modules/dependencies/navigation/nav-keys.enum';

import { AuthGuard } from '@common-modules/shared/auth/services/auth.guard';
import { GroupsPageComponent } from '@common-modules/wlm-security/groups-page/groups-page.component';
import { UsersPageComponent } from '@common-modules/wlm-security/users-page/users-page.component';

const routes: Routes = [
  {
    path: '',
    component: GroupsPageComponent,
    canLoad: [AuthGuard],
    canActivate: [AuthGuard],
    // #18328: Uncomment this to test the Auth guard.
    data: {
      navKey: NavKeys.Groups,
    },
  },
  {
    path: '',
    component: UsersPageComponent,
    canLoad: [AuthGuard],
    canActivate: [AuthGuard],
    data: {
      navKey: NavKeys.Users,
    },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class CtSecurityRoutingModule {}
